const generateSitemap = async () => {
  const baseUrl = 'https://teople.co.in';
  
  // Static routes
  const staticRoutes = [
    { url: '/', priority: '1.00', changefreq: 'daily', lastmod: new Date().toISOString() },
    { url: '/about', priority: '0.80', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/our-work', priority: '0.80', changefreq: 'weekly', lastmod: new Date().toISOString() },
    { url: '/service-section', priority: '0.80', changefreq: 'weekly', lastmod: new Date().toISOString() },
    { url: '/blog', priority: '0.80', changefreq: 'daily', lastmod: new Date().toISOString() },
    { url: '/career', priority: '0.80', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/contact-us', priority: '0.80', changefreq: 'monthly', lastmod: new Date().toISOString() },
    
    // Service pages
    { url: '/web-development', priority: '0.80', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/mobile-development', priority: '0.80', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/cloud-services', priority: '0.80', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/product-development', priority: '0.80', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/hw-sw-integration', priority: '0.80', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/ai-ml-development', priority: '0.80', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/staffing-solution', priority: '0.80', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/ui-design', priority: '0.80', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/data-science', priority: '0.80', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/iot-development', priority: '0.80', changefreq: 'monthly', lastmod: new Date().toISOString() },
    
    // Expertise pages
    { url: '/expertise/java', priority: '0.64', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/expertise/spring-boot', priority: '0.64', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/expertise/node-js', priority: '0.64', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/expertise/python', priority: '0.64', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/expertise/java-script', priority: '0.64', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/expertise/react-js', priority: '0.64', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/expertise/angular', priority: '0.64', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/expertise/pwa', priority: '0.64', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/expertise/aws', priority: '0.64', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/expertise/my-sql', priority: '0.64', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/expertise/git-lab', priority: '0.64', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/expertise/tailwind', priority: '0.64', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/expertise/docker', priority: '0.64', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/expertise/jenkins', priority: '0.64', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/expertise/vuejs', priority: '0.64', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/expertise/jira', priority: '0.64', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/expertise/ai-ml', priority: '0.64', changefreq: 'monthly', lastmod: new Date().toISOString() },
    { url: '/expertise/data-science', priority: '0.64', changefreq: 'monthly', lastmod: new Date().toISOString() }
  ];

  // Fetch dynamic content (blog posts, projects, etc.)
  const dynamicRoutes = await fetchDynamicRoutes();
  
  const allRoutes = [...staticRoutes, ...dynamicRoutes];

  const sitemap = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">
<!--  created with Teople Technologies sitemap generator  -->
${allRoutes.map(route => `<url>
<loc>${baseUrl}${route.url}</loc>
<lastmod>${route.lastmod}</lastmod>
<priority>${route.priority}</priority>
</url>`).join('\n')}
</urlset>`;

  return sitemap;
};

// Function to fetch dynamic routes (blog posts, projects, etc.)
const fetchDynamicRoutes = async () => {
  const routes = [];
  
  try {
    // Add blog posts (replace with your actual blog data source)
    const blogPosts = await fetchBlogPosts();
    blogPosts.forEach(post => {
      routes.push({
        url: `/blog/${post.slug}`,
        lastmod: post.updatedAt || new Date().toISOString(),
        priority: '0.64'
      });
    });

    // Add project pages
    const projects = await fetchProjects();
    projects.forEach(project => {
      routes.push({
        url: `/project/${project.slug}`,
        lastmod: project.updatedAt || new Date().toISOString(),
        priority: '0.51'
      });
    });

    // Add career openings
    const careers = await fetchCareerOpenings();
    careers.forEach(career => {
      routes.push({
        url: `/career/${career.slug}`,
        lastmod: career.updatedAt || new Date().toISOString(),
        priority: '0.64'
      });
    });

  } catch (error) {
    console.error('Error fetching dynamic routes:', error);
  }
  
  return routes;
};

// Placeholder functions - replace with your actual data fetching logic
const fetchBlogPosts = async () => {
  // Replace with actual API call or database query
  return [];
};

const fetchProjects = async () => {
  // Replace with actual API call or database query
  return [];
};

const fetchCareerOpenings = async () => {
  // Replace with actual API call or database query
  return [];
};

export default generateSitemap;